import React, { useEffect, useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import Select from 'react-select';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

const AddCategoryForm = ({
  value,
  onChange,
  slug,
  setSlug,
  shortCode,
  setShortCode,
  imageFile,
  setImageFile,
  onSubmit
}) => {
  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    const countryNames = countries.getNames('en', { select: 'official' });
    const options = Object.entries(countryNames).map(([code, label]) => ({
      value: code,
      label,
    }));
    setCountryOptions(options);
  }, []);

  const handleCountrySelect = (selected) => {
    if (selected) {
      setShortCode(selected.value); // ISO Alpha-2 code (e.g., "IN", "US")
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 3 }}>
      <TextField
        label="New Category Name"
        variant="outlined"
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Category Slug"
        variant="outlined"
        fullWidth
        value={slug}
        onChange={(e) => setSlug(e.target.value)}
        sx={{ mb: 2 }}
      />

      {/* Country dropdown to set shortCode */}
      <Select
        options={countryOptions}
        onChange={handleCountrySelect}
        placeholder="Select a country to set ShortCode"
        isClearable
        styles={{ container: (base) => ({ ...base, marginBottom: 16 }) }}
      />

      <TextField
        label="ShortCode"
        variant="outlined"
        fullWidth
        value={shortCode}
        onChange={(e) => setShortCode(e.target.value)} // still editable manually
        sx={{ mb: 2 }}
      />

      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files?.[0] || null)}
        style={{ marginBottom: 16 }}
      />

      <Button onClick={onSubmit} color="primary" variant="contained">
        Add Category
      </Button>
    </Box>
  );
};

export default AddCategoryForm;
